// Validação de CPF (algoritmo padrão dos dígitos verificadores)
export const isValidCPF = (value) => {
  const cpf = String(value || '').replace(/\D/g, '');

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const digits = cpf.split('').map(Number);
  const restOf = (count) => {
    const sum = digits.slice(0, count).reduce((acc, digit, index) => acc + digit * (count + 1 - index), 0);
    return (sum * 10) % 11 % 10;
  };

  return restOf(9) === digits[9] && restOf(10) === digits[10];
};

// Interpreta YYYY-MM-DD no fuso local (evita erro de 1 dia com new Date('YYYY-MM-DD'))
export const parseLocalDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

export const getAgeFromBirthDate = (birthDateStr, referenceDate = new Date()) => {
  const birth = parseLocalDate(birthDateStr);
  if (!birth) return null;

  const today = new Date(
    referenceDate.getFullYear(),
    referenceDate.getMonth(),
    referenceDate.getDate()
  );

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

/**
 * Valida data de nascimento e faixa etária.
 * @returns {{ valid: boolean, age: number|null, error: string|null }}
 */
export const validateBirthDateAge = (
  birthDateStr,
  { minAge = 0, maxAge = 120, required = true } = {}
) => {
  if (!birthDateStr || String(birthDateStr).trim() === '') {
    return {
      valid: !required,
      age: null,
      error: required ? 'Informe a data de nascimento' : null,
    };
  }

  const birth = parseLocalDate(birthDateStr);
  if (!birth) {
    return { valid: false, age: null, error: 'Data de nascimento inválida' };
  }

  const today = new Date();
  const todayLocal = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  if (birth > todayLocal) {
    return {
      valid: false,
      age: null,
      error: 'A data de nascimento não pode ser futura',
    };
  }

  const age = getAgeFromBirthDate(birthDateStr, today);
  if (age === null || age < 0) {
    return { valid: false, age: null, error: 'Data de nascimento inválida' };
  }
  if (age < minAge) {
    return {
      valid: false,
      age,
      error:
        minAge === 18
          ? 'O titular deve ter pelo menos 18 anos de idade'
          : `A idade mínima permitida é ${minAge} anos`,
    };
  }
  if (age > maxAge) {
    return {
      valid: false,
      age,
      error: 'A data parece estar equivocada. Por favor, verifique a data de nascimento.',
    };
  }

  return { valid: true, age, error: null };
};
